import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CoreService } from './../core/services/core.service';
import { AppConfigurationService } from './../../cemexng2components/components/app-configuration';
import { PaymentEngineService } from './services/payment-engine.service';
import { AdvancePaymentFormService } from './services/advance-payment-form.service';
import { BankService } from './services/bank.service';
import { PaymentService } from './services/payment.service';
import { ReasonCodeService } from './services/reason-code.service';
import { RegularPaymentFormService } from './services/regular-payment-form.service';
import { FinancialDocumentsService } from './../financial-documents/services/financial-documents.service';
import { StoreModule } from '@ngrx/store';
import { reducers } from './store/reducers/index';
import { EffectsModule } from '@ngrx/effects';
import { PaymentProcessEffect } from './store/effects/payment-process.effect';
import { PaymentConfigurationEffect } from './store/effects/payment-configuration.effect';
import { PaymentLayoutEffect } from './store/effects/payment-layout.effect';
import { AlertModule, AlertService } from '@app/shared/alert';

@NgModule({
    imports: [
        StoreModule.forFeature('payments', reducers),
        EffectsModule.forFeature([PaymentProcessEffect, PaymentConfigurationEffect, PaymentLayoutEffect]),
        AlertModule
    ],
    providers: [
        CoreService,
        AppConfigurationService,
        PaymentEngineService,
        AdvancePaymentFormService,
        BankService,
        PaymentService,
        ReasonCodeService,
        RegularPaymentFormService,
        FinancialDocumentsService,
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})

export class PaymentsCoreModule { }
